import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import { setupKeycloak } from './plugins/keycloak';

async function bootstrap() {
    const app = createApp(App);

    await setupKeycloak(app);

    app.mount('#app');
}
bootstrap();